const CITE_CATEGORY = [
    {
        value: '101',
        label: '101'
    },
    {
        value: '102',
        label: '102'
    },
    {
        value: '103',
        label: '103'
    },
    {
        value: 'X',
        label: 'X'
    },
    {
        value: 'Y',
        label: 'Y'
    },
    {
        value: 'A',
        label: 'A'
    },
    {
        value: 'D',
        label: 'D'
    },
    {
        value: 'E',
        label: 'E'
    },
    {
        value: 'L',
        label: 'L'
    },
    {
        value: 'R',
        label: 'R'
    },
    {
        value: 'T',
        label: 'T'
    }
];
const ANCS_TYPE = [
    {
        value: 'ACADEMY',
        label: 'advanceSearchForm.anstype.academy'
    },
    {
        value: 'COMPANY',
        label: 'advanceSearchForm.anstype.company'
    },
    {
        value: 'GOVERNMENT',
        label: 'advanceSearchForm.anstype.government'
    },
    {
        value: 'PERSON',
        label: 'advanceSearchForm.anstype.person'
    },
    {
        value: 'HOSPITAL',
        label: 'advanceSearchForm.anstype.hospital'
    },
    {
        value: 'BANK',
        label: 'advanceSearchForm.anstype.bank'
    },
    {
        value: 'OTHER',
        label: 'advanceSearchForm.anstype.other'
    }
];
const ANS_TYPE = [
    {
        value: 'ACADEMY',
        label: 'advanceSearchForm.anstype.academy'
    },
    {
        value: 'COMPANY',
        label: 'advanceSearchForm.anstype.company'
    },
    {
        value: 'GOVERNMENT',
        label: 'advanceSearchForm.anstype.government'
    },
    {
        value: 'PERSON',
        label: 'advanceSearchForm.anstype.person'
    },
    {
        value: 'HOSPITAL',
        label: 'advanceSearchForm.anstype.hospital'
    },
    {
        value: 'BANK',
        label: 'advanceSearchForm.anstype.bank'
    },
    {
        value: 'OTHER',
        label: 'advanceSearchForm.anstype.other'
    }
];
const PATENT_TYPE = [
    {
        value: 'A',
        label: 'advanceSearchForm.patenttype.application'
    },
    {
        value: 'B',
        label: 'advanceSearchForm.patenttype.patent'
    },
    {
        value: 'U',
        label: 'advanceSearchForm.patenttype.utility'
    },
    {
        value: 'D',
        label: 'advanceSearchForm.patenttype.design'
    }
];
const GOV = [
    {
        value: '1',
        label: 'advanceSearchForm.gov.active'
    }
];
const CASE_NATURE = [{
        'value': '民事案件',
        'label': 'advanceSearchForm.searchinput.Civil_CASE'
    }, {
        'value': '行政案件',
        'label': 'advanceSearchForm.searchinput.Administrative_CASE'
    }, {
        'value': '执行案件',
        'label': 'advanceSearchForm.searchinput.Economic_CASE'
    }, {
        'value': '管辖案件',
        'label': 'advanceSearchForm.searchinput.Jurisdictional_CASE'
    },
    {
        'value': '其他案件',
        'label': 'advanceSearchForm.searchinput.Other_CASE'
    }];
const CASE_LEVEL = [{
        'value': '1',
        'label': 'advanceSearchForm.searchinput.CASE_LEVEL.1'
    }, {
        'value': '2',
        'label': 'advanceSearchForm.searchinput.CASE_LEVEL.2'
    }];
const CASE_DOC_TYPE = [{
        'value': '1',
        'label': 'advanceSearchForm.searchinput.CASE_DOC_TYPE.1'
    }, {
        'value': '2',
        'label': 'advanceSearchForm.searchinput.CASE_DOC_TYPE.2'
    }, {
        'value': '3',
        'label': 'advanceSearchForm.searchinput.CASE_DOC_TYPE.3'
    }, {
        'value': '4',
        'label': 'advanceSearchForm.searchinput.CASE_DOC_TYPE.4'
    },
    {
        'value': '5',
        'label': 'advanceSearchForm.searchinput.CASE_DOC_TYPE.5'
    }];
const COURT_GRADE = [{
        'value': '最高法院 ',
        'label': '最高法院'
    }, {
        'value': '高级法院',
        'label': '高级法院'
    }, {
        'value': '中级法院',
        'label': '中级法院'
    }, {
        'value': '基层法院',
        'label': '基层法院'
    }, {
        'value': '专门法院',
        'label': '专门法院'
    }];
const CASE_REGION = [{
        'value': '',
        'label': '全部'
    }, {
        'value': '北京',
        'label': 'advanceSearchForm.searchinput.Beijing'
    }, {
        'value': '天津',
        'label': 'advanceSearchForm.searchinput.Tianjin'
    }, {
        'value': '重庆',
        'label': 'advanceSearchForm.searchinput.Chongqing'
    }, {
        'value': '上海',
        'label': 'advanceSearchForm.searchinput.Shanghai'
    }, {
        'value': '河北',
        'label': 'advanceSearchForm.searchinput.Hebei'
    }, {
        'value': '山西',
        'label': 'advanceSearchForm.searchinput.Shanxi'
    }, {
        'value': '辽宁',
        'label': 'advanceSearchForm.searchinput.Liaoning'
    }, {
        'value': '吉林',
        'label': 'advanceSearchForm.searchinput.Jilin'
    }, {
        'value': '黑龙江',
        'label': 'advanceSearchForm.searchinput.Heilongjiang'
    }, {
        'value': '江苏',
        'label': 'advanceSearchForm.searchinput.Jiangsu'
    }, {
        'value': '浙江',
        'label': 'advanceSearchForm.searchinput.Zhejiang'
    }, {
        'value': '安徽',
        'label': 'advanceSearchForm.searchinput.Anhui'
    }, {
        'value': '福建',
        'label': 'advanceSearchForm.searchinput.Fujian'
    }, {
        'value': '江西',
        'label': 'advanceSearchForm.searchinput.Jiangxi'
    }, {
        'value': '山东',
        'label': 'advanceSearchForm.searchinput.Shandong'
    }, {
        'value': '河南',
        'label': 'advanceSearchForm.searchinput.Henan'
    }, {
        'value': '湖北',
        'label': 'advanceSearchForm.searchinput.Hubei'
    }, {
        'value': '湖南',
        'label': 'advanceSearchForm.searchinput.Hunan'
    }, {
        'value': '广东',
        'label': 'advanceSearchForm.searchinput.Guangdong'
    }, {
        'value': '海南',
        'label': 'advanceSearchForm.searchinput.Hainan'
    }, {
        'value': '四川',
        'label': 'advanceSearchForm.searchinput.Sichuan'
    }, {
        'value': '贵州',
        'label': 'advanceSearchForm.searchinput.Guizhou'
    }, {
        'value': '云南',
        'label': 'advanceSearchForm.searchinput.Yunnan'
    }, {
        'value': '陕西',
        'label': 'advanceSearchForm.searchinput.Shaanxi'
    }, {
        'value': '甘肃',
        'label': 'advanceSearchForm.searchinput.Gansu'
    }, {
        'value': '青海',
        'label': 'advanceSearchForm.searchinput.Qinghai'
    }, {
        'value': '台湾',
        'label': 'advanceSearchForm.searchinput.Taiwan'
    }, {
        'value': '内蒙古',
        'label': 'advanceSearchForm.searchinput.InnerMongolia'
    }, {
        'value': '广西',
        'label': 'advanceSearchForm.searchinput.Guangxi'
    }, {
        'value': '西藏',
        'label': 'advanceSearchForm.searchinput.Tibet'
    }, {
        'value': '宁夏',
        'label': 'advanceSearchForm.searchinput.Ningxia'
    }, {
        'value': '新疆',
        'label': 'advanceSearchForm.searchinput.Xinjiang'
    }, {
        'value': '香港',
        'label': 'advanceSearchForm.searchinput.HongKong'
    }, {
        'value': '澳门',
        'label': 'advanceSearchForm.searchinput.Macau'
    }];
const OUTCOME_STATUS = [{
        'value': '',
        'label': 'All'
    }, {
        'value': '"Stayed (pending reexam and other)"',
        'label': 'Stayed (pending reexam and other)'
    }, {
        'value': '"Open (open original)"',
        'label': 'Open (open original)'
    }, {
        'value': '"Open (open after remand)"',
        'label': 'Open (open after remand)'
    }, {
        'value': '"Consolidated"',
        'label': 'Consolidated'
    }, {
        'value': '"Closed (on appeal)"',
        'label': 'Closed (on appeal)'
    }, {
        'value': '"Closed (closed after remand)"',
        'label': 'Closed (closed after remand)'
    }, {
        'value': '"Closed (closed)"',
        'label': 'Closed (closed)'
    }];
const EXCLUSIVITY = [
    {
        'value': 'Exclusive',
        'label': 'advanceSearchForm.searchinput.exec_exc'
    }, {
        'value': 'Non-Exclusive',
        'label': 'advanceSearchForm.searchinput.exec_nonexc'
    }, {
        'value': 'Multi-Exclusivity',
        'label': 'advanceSearchForm.searchinput.exec_munexc'
    }, {
        'value': 'Sole',
        'label': 'advanceSearchForm.searchinput.exec_sole'
    }, {
        'value': 'Cross',
        'label': 'advanceSearchForm.searchinput.exec_cros'
    }, {
        'value': 'Sub',
        'label': 'advanceSearchForm.searchinput.exec_sub'
    }, {
        'value': 'Other',
        'label': 'advanceSearchForm.searchinput.exec_other'
    }
];
const PLE_STAGE = [{
        'value': '',
        'label': 'common.all'
    }, {
        'value': '1',
        'label': 'advanceSearchForm.searchinput.pleStage_effective'
    }, {
        'value': '2',
        'label': 'advanceSearchForm.searchinput.pleStage_logout'
    }];
const RIDTP = [{
        'value': '',
        'label': 'common.all'
    }, {
        'value': 'IPR',
        'label': 'advanceSearchForm.searchinput.rid_int'
    }, {
        'value': 'PGR',
        'label': 'advanceSearchForm.searchinput.rid_pgr'
    }, {
        'value': 'CBM',
        'label': 'advanceSearchForm.searchinput.rid_cbm'
    }];
const RIDTP_CN = [{
        'value': '',
        'label': 'common.all'
    }, {
        'value': 'FS',
        'label': 'advanceSearchForm.searchinput.rid_fs'
    }, {
        'value': 'WX',
        'label': 'advanceSearchForm.searchinput.rid_wx'
    }, {
        'value': 'KS',
        'label': 'advanceSearchForm.searchinput.rid_ks'
    }];
const RIDTP_EP = [{
        'value': '',
        'label': 'common.all'
    }, {
        'value': 'G',
        'label': 'advanceSearchForm.searchinput.rid_G'
    }, {
        'value': 'T',
        'label': 'advanceSearchForm.searchinput.rid_T'
    }, {
        'value': 'J',
        'label': 'advanceSearchForm.searchinput.rid_J'
    }, {
        'value': 'W',
        'label': 'advanceSearchForm.searchinput.rid_W'
    }, {
        'value': 'R',
        'label': 'advanceSearchForm.searchinput.rid_R'
    }, {
        'value': 'D',
        'label': 'advanceSearchForm.searchinput.rid_D'
    }];
const TRIAL_GRADE_CN = [{
        'value': '',
        'label': 'advanceSearchForm.searchinput.ALL_INSTANCE'
    }, {
        'value': '一审',
        'label': 'advanceSearchForm.searchinput.First_INSTANCE'
    }, {
        'value': '二审',
        'label': 'advanceSearchForm.searchinput.Second_INSTANCE'
    }, {
        'value': '再审',
        'label': 'advanceSearchForm.searchinput.Third_INSTANCE'
    }];
const multiDropdownMap = {
    ANCS_TYPE,
    ANS_TYPE,
    PATENT_TYPE,
    EXCLUSIVITY,
    CITE_CATEGORY,
    CASE_NATURE,
    CASE_LEVEL,
    CASE_DOC_TYPE,
    COURT_GRADE
};
const multiMap = {
    GOV,
    'ATC_VALUE': [
        {
            'value': '1',
            'label': 'advanceSearchForm.searchinput.atc_value_1'
        },
        {
            'value': '0',
            'label': 'advanceSearchForm.searchinput.atc_value_0'
        }
    ],
    UP_STATUS: [
        {
            'value': '0',
            'label': 'advanceSearchForm.searchinput.up_status_0'
        },
        {
            'value': '1',
            'label': 'advanceSearchForm.searchinput.up_status_1'
        },
        {
            'value': '2',
            'label': 'advanceSearchForm.searchinput.up_status_2'
        },
        {
            'value': '3',
            'label': 'advanceSearchForm.searchinput.up_status_3'
        }
    ],
    EFAM_STATUS: [
        {
            'value': '0',
            'label': 'advanceSearchForm.searchinput.efam_status_0'
        },
        {
            'value': '1',
            'label': 'advanceSearchForm.searchinput.efam_status_1'
        },
        {
            'value': '2',
            'label': 'advanceSearchForm.searchinput.efam_status_2'
        },
        {
            'value': '999',
            'label': 'advanceSearchForm.searchinput.efam_status_999'
        }
    ]
};
const dropdownMap = {
    CASE_REGION,
    OUTCOME_STATUS,
    PLE_STAGE,
    RIDTP,
    RIDTP_CN,
    RIDTP_EP,
    TRIAL_GRADE: TRIAL_GRADE_CN,
    TRIAL_GRADE_CN,
};
export { multiMap, dropdownMap, multiDropdownMap };
